import CryptoJS from 'crypto-js/crypto-js';
function AesTools() { }

AesTools.prototype = {
    // 默认的 KEY 与 iv 与后端保持一致 ，不采用后端传值密钥
    key: CryptoJS.enc.Utf8.parse('D3JlatWvL8qqA6MJ'),// 密钥
    iv: CryptoJS.enc.Utf8.parse('aMUpdkrwqOt4BDco'),// 偏移量

    Encrypt: function (str) {

        let srcs = CryptoJS.enc.Utf8.parse(str);
        var encrypted = CryptoJS.AES.encrypt(srcs, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        });

        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },
    Decrypt: function (str) {
        let base64 = CryptoJS.enc.Base64.parse(str);
        let src = CryptoJS.enc.Base64.stringify(base64);

        var decrypt = CryptoJS.AES.decrypt(src, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        });

        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    }
}
export {
    AesTools
}